
import api from './api'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'lib-flexible/flexible'
import 'vant/lib/index.css';
import store from './store'
Vue.use(Vant);
Vue.use(require('vue-wechat-title'))

Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.prototype.imgUrl='https://img.yzcdn.cn/vant/logo.png'


new Vue({
  el: '#app',
  data(){
	  return{
		  city: '哈尔滨',//全局变量可更改你怕吗
	  }
  },
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js